import * as yup from "yup";

export const updatePatientSchema = yup
  .object()
  .shape({
    patientId: yup.string().required("Id is required"),
    firstName: yup
      .string("Enter a valid first name")
      .required("First name is required"),
    lastName: yup
      .string("Enter a valid last name")
      .required("Last name is required"),
    contactNumber: yup
      .string("Enter a valid contact number")
      .matches(/^[0-9]*$/, "Contact number should only contain numbers")
      .min(11, "Contact number must have a length of 11 characters")
      .required("Contact number is required"),
    email: yup
      .string()
      .email("Enter a valid email")
      .required("Email is required"),
    address: yup
      .string("Enter a valid address")
      .required("Address is required"),
    dateOfBirth: yup
      .date()
      .max(new Date(), "Future dates are not allowed")
      .typeError("Date of birth must be a valid date")
      .nullable(),
    sex: yup.string().nullable(),
    sourceId: yup.string("Enter a valid source").required("Source is required"),
  })
  .required();
